
import { defineComponent, computed } from 'vue'
import '@he-tree/vue3/dist/he-tree-vue3.css'
import { Draggable } from '@he-tree/vue3'
import VariablesTreeRenderless from '@/components/Shared/VariablesTreeRenderless'
import store from '@/store'
import { useModalConfirm, useModalPrompt } from '@/utils/useModalDialogs'
import { VariableNodeInterface } from '@/models/tree/VariableNode.interface'
import FolderNameInput from '@/components/Shared/FolderNameInput.vue'
import ImageVariableIcon from '@/components/Shared/ImageVariableIcon.vue'
import VariableButtonsRow from './VariableButtonsRow.vue'
import ThePagination from '@/components/Shared/ThePagination.vue'
import PerPageSelector from '@/components/Shared/PerPageSelector.vue'

export default defineComponent({
  components: {
    VariablesTreeRenderless,
    Draggable,
    FolderNameInput,
    VariableButtonsRow,
    ImageVariableIcon,
    ThePagination,
    PerPageSelector
  },
  props: {
    type: { type: String, required: true },
    editModeAllowed: { type: Boolean, default: true },
    loading: { type: Boolean, default: false }
  },
  emits: ['itemClicked', 'paginate'],
  setup() {
    const totalCount = computed(() => store.state.pagination.totalCount)
    const perPageOptions = [50, 100, 250, 500]

    const removeFolderHandler = (
      removeFolderCallback: (node: VariableNodeInterface) => void,
      node: VariableNodeInterface
    ) => {
      useModalConfirm(
        `The folder "${node.name}" will be deleted. Are you sure?`,
        () => removeFolderCallback(node),
        () => undefined
      )
    }
    const createFolderWrapperHandler = (
      createFolderCallback: (name: string) => void
    ) => {
      useModalPrompt('Enter folder name:', '', createFolderCallback)
    }

    return {
      totalCount,
      perPageOptions,
      removeFolderHandler,
      createFolderWrapperHandler
    }
  },
  methods: {
    variableClickedHandler(node: VariableNodeInterface) {
      this.$emit('itemClicked', node)
    },
    variableNodeClasses(node: VariableNodeInterface) {
      const classes = 'variable-node uk-flex'
      const nodeType = node.folder ? 'folder' : 'item'
      return classes + ` variable-node-${nodeType}`
    },
    nodeIconClasses(node: VariableNodeInterface) {
      return `node-icon-${this.nodeIcon(node)}`
    },
    nodeIconAttrs(node: VariableNodeInterface) {
      const ratio = node.folder ? '0.9' : '0.7'
      return `icon: ${this.nodeIcon(node)}; ratio: ${ratio}`
    },
    nodeIcon(node: VariableNodeInterface) {
      return node.folder ? 'folder' : this.itemIcon()
    },
    isImageVariableNode(node: VariableNodeInterface) {
      return this.type === 'image' && !node.folder
    },
    itemIcon() {
      return (
        {
          image: 'image',
          calendar_event: 'link'
        }[this.type] || 'file-text'
      )
    }
  }
})
